var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a", { staticClass: "single-column", attrs: { href: _vm.link } }, [
    _c("div", { staticClass: "single-column--image" }, [
      _c("img", {
        directives: [
          {
            name: "lazy",
            rawName: "v-lazy",
            value: _vm.sizedImage,
            expression: "sizedImage",
          },
        ],
        attrs: { alt: "" },
      }),
    ]),
    _c("p", { staticClass: "single-column--title subtitle" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }